import {
  API,
  Request
} from '@/lib/index.js'

export default {
  namespaced: true,
  state: {
    commentList: []
  },
  mutations: {
    noAction () {      
    },
    updateCommentList (state, payload) {
      state.commentList = payload
    }
  },
  getters: {

  },
  actions: {
    submitComment ({commit, rootState}, payload) {
      console.log(11, rootState.userInfo)
      return new Promise((resolve, reject) => {
        Request(API.submitComment, {
          request: {
            courseId: payload.courseId,
            parentId: payload.parentId || undefined,
            content: payload.content,
            username: rootState.userInfo.username,
            avatarUrl: rootState.userInfo.avatarUrl
          }
        }).then((resp) => {
          resolve(resp)
          commit('noAction')
        }).catch(() => {
          reject()
        })
      })
    },
    queryCommentList ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryCommentList, {
          request: {
            courseId: payload.courseId,
            page: payload.pageNum,
            pageSize: payload.pageSize
          }
        }).then((resp) => {
          resolve(resp)
          console.log(111, resp)
          commit('updateCommentList', resp)
        }).catch(() => {
          reject()
        })
      })
    },
    deleteComment ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.deleteComment, {
          request: {
            commentId: payload.commentId
          }
        }).then((resp) => {
          resolve(resp)
          commit('noAction')
        }).catch(() => {
          reject()
        })
      })
    }
  }
}
